import { Injectable } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { TranslocoService } from '@ngneat/transloco';
import { Store } from '@ngxs/store';
import { NotificationErrorProvider, TranslocoErrorSpecification } from '@platform-frontend/ui-tools';
import { Observable, of } from 'rxjs';
import { map, switchMap, take } from 'rxjs/operators';
import { ERR_SPECS_FOR_ERROR_TYPES } from './error-specifications';

@Injectable({ providedIn: 'root' })
export class ErrorSpecificationProvider {
  constructor(
    private activatedRoute: ActivatedRoute,
    private notificationErrorProvider: NotificationErrorProvider,
    private readonly translocoService: TranslocoService,
    private readonly store: Store
  ) {}

  getErrorSpecification(
    ignore: string[] = [],
    notificationButtonClickHandler?: () => void,
    tryAgainButtonClickHandler?: () => void,
    specificErrorSpecs?: (translocoService: TranslocoService, store: Store) => TranslocoErrorSpecification[],
    notificationButtonName?: Observable<string>
  ): Observable<TranslocoErrorSpecification> {
    const platformErrorSpecs = ERR_SPECS_FOR_ERROR_TYPES(this.translocoService, tryAgainButtonClickHandler);
    const specs = specificErrorSpecs ? [...platformErrorSpecs, ...specificErrorSpecs(this.translocoService, this.store)] : platformErrorSpecs;
    return this.activatedRoute.queryParamMap.pipe(
      take(1),
      map(queryParams => queryParams.get('errorType')),
      map(errorType => (errorType ? specs.find(specification => specification.forErrorTypes?.includes(errorType)) : undefined)),
      switchMap(specificationForErrorType =>
        specificationForErrorType
          ? of(specificationForErrorType)
          : this.notificationErrorProvider.getErrorSpecification(ignore, notificationButtonClickHandler, notificationButtonName)
      )
    );
  }
}
